// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2T0H4","col":"styles_col__oy38f"};